import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalGalleryComponent } from 'src/app/shared/components/modal-gallery/modal-gallery.component';
import { imgGallery } from 'src/app/shared/models/imgGallery';

@Component({
  selector: 'app-carrousel-img',
  templateUrl: './carrousel-img.component.html',
  styleUrls: ['./carrousel-img.component.scss']
})
export class CarrouselImgComponent implements OnInit {

  datos: any;
  carousel = false;
  archivo: any;
  @Input() title: string;
  gallery: imgGallery[] = [];
  @Input() data: any;
  @Input() background = '#003567';
  styleTitle = 'blanco';


  @ViewChild('carouselContainer') carouselContainer: ElementRef;
  @Input() cant: number = 3; // Cantidad máxima de cards por vista
  isDesktop: boolean = true;
  currentIndex: number = 0;
  lockedLeft = true;
  lockedRight = false;
  componentId = 'carousel-' + Math.random().toString(36).substring(7);
  carouselTransform: string = 'translateX(0)';  // Propiedad vinculada para el desplazamiento
  autoplayInterval: any;

  constructor(public dialog: MatDialog) {

  }
  ngOnInit(): void {
    if (this.background == '#ffffff') {
      this.styleTitle = "azul";
    }
    if (this.data) {
      var i = 0;

      this.data.forEach(element => {
        let img = new imgGallery();
        img.id = element.id;
        img.path = element.path;
        img.position = i;
        i++;
        this.gallery.push(img)
      });
    }
    this.checkScreenSize();
    this.startAutoPlay();


  }
  openModal(id: number): void {
    this.dialog.open(ModalGalleryComponent, { panelClass: 'custom-dialog-container', data: { titulo: this.title, gallery: this.gallery, id: id } });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();

  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth > 768;
    this.cant = (this.isDesktop) ? 3 : 1;
  }

  // Mover a la izquierda
  moveLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha izquierda si estamos en el primer conjunto
    this.lockedLeft = this.currentIndex === 0;
    this.lockedRight = false; // Desbloquear flecha derecha
  }

  // Mover a la derecha
  moveRight() {
    if (this.currentIndex + this.cant < this.gallery.length) {
      this.currentIndex += 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha derecha si ya no hay más elementos
    this.lockedRight = this.currentIndex + this.cant >= this.gallery.length;
    this.lockedLeft = false; // Desbloquear flecha izquierda
  }

  // Actualizar la posición del carrusel usando transform
  updateCarouselPosition() {
    // Calcula el desplazamiento en porcentaje
    const cardWidth = 100 / this.cant;  // El ancho de cada card en porcentaje
    const offset = this.currentIndex * cardWidth;  // Desplazamiento total basado en el índice
    this.carouselTransform = `translateX(-${offset}%)`;  // Actualiza el estilo de transform
    this.restartAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }


  startAutoPlay() {
    this.autoplayInterval = setInterval(() => {
      if (this.currentIndex + this.cant < this.gallery.length) {
        this.moveRight();
      } else {
        this.currentIndex = 0;
        this.updateCarouselPosition();
      }
    }, 3000);
  }

  stopAutoPlay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  restartAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }
}
